"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const WhatsappIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.904 4.31c-.145-.349-.256-.362-.476-.37a4.247 4.247 0 00-.251-.01c-.287 0-.587.084-.767.27-.22.224-.767.749-.767 1.825s.784 2.116.89 2.262c.11.145 1.53 2.385 3.734 3.298 1.723.714 2.235.648 2.627.564.573-.123 1.291-.546 1.472-1.058.18-.511.18-.948.128-1.04-.053-.093-.199-.146-.419-.256-.22-.11-1.291-.64-1.494-.71-.199-.075-.388-.048-.538.163-.211.296-.419.595-.586.776-.132.141-.348.159-.53.084-.242-.101-.92-.34-1.758-1.085-.648-.577-1.089-1.296-1.216-1.512-.128-.22-.014-.348.088-.467.11-.137.216-.234.326-.362.11-.128.172-.194.242-.344.075-.145.022-.295-.03-.406-.053-.11-.494-1.186-.675-1.622zM7.998.5C3.863.5.5 3.864.5 8c0 1.64.529 3.161 1.428 4.396l-.934 2.786 2.882-.92A7.44 7.44 0 008.002 15.5c4.135 0 7.498-3.364 7.498-7.5S12.137.5 8.002.5h-.004z",
    clipRule: "evenodd"
  })))
});
WhatsappIcon.displayName = 'WhatsappIcon';
var _default = exports.default = WhatsappIcon;